import React, { useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import useOnClickOutside from 'hooks/useOnClickOutsideRef.hook';
import useTip from 'hooks/useTip.hook';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';
import fromAnyToString from 'utils/converters/fromAnyToString';
import focusElement from 'utils/dom/focusElement.util';

import CN from './AllowanceInput.module.scss';

const AllowanceInput = ({ name, value: valueFromProp, onChange, onBlur, onFocus, calendarMode }) => {
  const value = fromAnyToString(valueFromProp);
  const { val: isSpanShown, yay: showSpan, nay: hideSpan } = useTip(true);
  const inputRef = useRef(null);

  useOnClickOutside(inputRef, () => {
    inputRef.current.type = 'hidden';
    showSpan();
  });

  const handleClick = useCallback(
    () => {
      if (inputRef.current) {
        inputRef.current.type = 'text';
        focusElement(inputRef.current);
        hideSpan();
        // set cursor at the end of input value days
        const len = inputRef.current.value.length;
        inputRef.current.setSelectionRange(len, len);
      } else {
        inputRef.current.type = 'number';
        focusElement(inputRef.current);
        hideSpan();
      }
    },
    [hideSpan],
  );

  return (
    <div className={cn(CN.component, CN[calendarMode])}>
      <input
        ref={inputRef}
        name={name}
        type="hidden"
        className={CN.input}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
      />
      {isSpanShown && (
        <button className={CN.suffix} onClick={handleClick}>
          {value ? `${value} days` : '-'}
        </button>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

export default connect(mapStateToProps)(AllowanceInput);
